export default function capitalizeString(string = "Home") {
    return string.charAt(0).toUpperCase() + string.slice(1);

}